import _cloneDeep from 'lodash/cloneDeep';

export default {
  cardTypesResults: (state) => _cloneDeep(state.cardTypesResults),
};
